// extracted by mini-css-extract-plugin
export default {"formLayout":"SkinSensitivityForm-module-formLayout-AMN0s","wrapper":"SkinSensitivityForm-module-wrapper-in9zc"};